import React, { createContext, useContext } from 'react';

const CnGoodsContext = createContext();

export const CnGoodsProvider = ({ children, value }) => {
  return <CnGoodsContext.Provider value={value}>{children}</CnGoodsContext.Provider>;
};

export const useCnGoodsContext = () => {
  const context = useContext(CnGoodsContext);
  return context || {};
};

export default CnGoodsContext;
